import "./Home.module.css";
import GatewayNavigation from "@/reusable_sections/Header";
import IhrStressfreierUmzugInHamburg from "./sections/IhrStressfreierUmzugInHamburg";
import TheHallOfAchievements from "./sections/TheHallOfAchievements";
import GenerativeAiSuite from "./sections/GenerativeAiSuite";
import TheRoadToClosing from "./sections/TheRoadToClosing";
import BrandExcellencePillars from "./sections/BrandExcellencePillars";
import CreatorTestimonials from "./sections/CreatorTestimonials";
import ReadyToPrint from "./sections/ReadyToPrint";
import PremiumServices from "./sections/PremiumServices";
import Footer from "@/reusable_sections/Footer";
import About from "./sections/About";
import AboutUs from "./sections/AboutUs";
import GlobalMarkets from "./sections/GlobalMarkets";
export default function HomePage() {
  return <div>
      <GatewayNavigation />
      <IhrStressfreierUmzugInHamburg />
      <GlobalMarkets />
      <TheHallOfAchievements />
      <GenerativeAiSuite />
      <TheRoadToClosing />
      <BrandExcellencePillars />
      <About />
      <AboutUs />
      <CreatorTestimonials />
      <ReadyToPrint />
      <Footer />
    </div>;
}